import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  header: {
    marginBottom: '1.75rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  },
  title: {
    fontWeight: 600,
    color: '#1a1a1a',
    marginBottom: '0.125rem'
  },
  subtitle: {
    color: '#6c757d',
    fontSize: '0.875rem'
  },
  selectAllContainer: {
    marginBottom: '1rem'
  },
  selectAllLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    cursor: 'pointer',
    fontSize: '0.875rem',
    color: '#424242',
    fontWeight: 500
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '60px 32px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    minHeight: '300px',
    justifyContent: 'center',
    border: '1px solid #e8e8e8',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)'
  },
  emptyStateIcon: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #4c4cff 0%, #6366f1 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
    boxShadow: '0 4px 16px rgba(76, 76, 255, 0.25)',
    '& svg': {
      color: '#fff'
    }
  },
  emptyStateText: {
    color: '#1a1a1a',
    fontWeight: 600,
    fontSize: '1.125rem',
    textAlign: 'center'
  },
  objectList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem'
  },
  objectListWithSelection: {
    paddingBottom: '5rem'
  },
  objectCard: {
    padding: '1rem 1.25rem',
    backgroundColor: '#fff',
    borderRadius: '10px',
    border: '1px solid #e8e8e8',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04)',
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.06)',
      transform: 'translateY(-1px)'
    }
  },
  objectCardCompleted: {
    backgroundColor: '#fafffe',
    borderLeft: '3px solid #22c55e',
    '&:hover': {
      transform: 'none',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04)'
    }
  },
  objectCardFailed: {
    borderLeft: '3px solid #ef4444',
    backgroundColor: '#fffbfb'
  },
  objectCardDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
    pointerEvents: 'none'
  },
  objectCardSelected: {
    borderColor: '#4c4cff',
    backgroundColor: '#fafaff',
    boxShadow: '0 0 0 1px rgba(76, 76, 255, 0.2), 0 2px 8px rgba(76, 76, 255, 0.1)'
  },
  objectCardContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1rem',
    overflow: 'hidden'
  },
  objectDetails: {
    flex: 1,
    display: 'grid',
    gridTemplateColumns: '3fr 1fr 2fr 1fr 1fr',
    alignItems: 'start',
    gap: '1rem',
    minWidth: 0
  },
  objectName: {
    minWidth: 0,
    overflow: 'hidden'
  },
  objectNameText: {
    fontWeight: 600,
    color: '#1a1a1a',
    fontSize: '0.9375rem'
  },
  objectId: {
    minWidth: 0
  },
  objectConnector: {
    minWidth: 0
  },
  objectDate: {
    minWidth: 0
  },
  fieldLabel: {
    color: '#9e9e9e',
    fontSize: '0.6875rem',
    marginBottom: '0.125rem',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
    fontWeight: 500
  },
  fieldValue: {
    color: '#424242',
    fontSize: '0.875rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  fieldValueWrap: {
    color: '#424242',
    fontSize: '0.875rem',
    wordBreak: 'break-word'
  },
  previewButton: {
    fontSize: '0.8125rem',
    whiteSpace: 'nowrap',
    flexShrink: 0
  },
  statusContainer: {
    marginTop: '0.625rem',
    paddingLeft: 'calc(20px + 1rem)'
  },
  statusText: {
    fontSize: '0.8125rem',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.375rem',
    padding: '0.25rem 0.75rem',
    borderRadius: '999px',
    fontWeight: 500
  },
  statusSuccess: {
    color: '#065f46',
    backgroundColor: '#ecfdf5'
  },
  statusWarning: {
    color: '#92400e',
    backgroundColor: '#fffbeb'
  },
  statusError: {
    color: '#991b1b',
    backgroundColor: '#fef2f2'
  },
  progressContainer: {
    marginTop: '0.75rem',
    animation: '$fadeInProgress 0.3s ease-in'
  },
  progressContainerAutomated: {
    marginLeft: '2.5rem'
  },
  '@keyframes fadeInProgress': {
    from: {
      opacity: 0,
      transform: 'translateY(-4px)'
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)'
    }
  }
});

export default useStyles;
